export default __webpack_public_path__ + "static/media/edit.ddf899bf.svg";